import Image from 'next/image';
import { Button } from '../buttons';
import Link from 'next/link';
import { ArrowUpRight, Menu } from 'lucide-react';
import { useState } from 'react';
import clsx from 'clsx'; // optional but useful

const PublicNavbar = () => {
  const [dropdown, setDropdown] = useState(false);
  return (
    <>
      <div className="w-full bg-cube sticky top-0 z-50 relative">
        <div className="container mx-auto">
          <div className="flex justify-between text-white items-center py-4">
            <Link href="/">
              <Image
                src="/assets/MeterCube_Logo_Primary_Ligh.svg"
                alt=""
                height={300}
                width={500}
                className="w-[205px] hidden md:block"
              />
              <Image
                src="/assets/public-metercube/Cube Asia Logo_Dark Icon.svg"
                alt=""
                height={64}
                width={64}
                className="w-8 md:hidden"
              />
            </Link>
            <div className="hidden md:flex gap-x-2">
              <Link href="https://cube.asia" target="_blank">
                <Button variant="outline-white" iconEnd={<ArrowUpRight />}>
                  Cube.asia
                </Button>
              </Link>

              <Link href="/login">
                <Button variant="white">Sign in</Button>
              </Link>
            </div>
            <button
              className="md:hidden"
              onClick={() => setDropdown(!dropdown)}
            >
              <Menu className="size-8" />
            </button>
          </div>
        </div>
        <div
          className={clsx(
            'absolute w-full z-40 overflow-hidden bg-white transition-all duration-300 ease-in-out md:hidden',
            dropdown
              ? 'max-h-[500px] opacity-100 translate-y-0'
              : 'max-h-0 opacity-0 -translate-y-4'
          )}
        >
          <div className="flex flex-col p-8">
            <Link href="https://cube.asia" target="_blank" className="mb-2">
              <Button
                variant="outline"
                iconEnd={<ArrowUpRight />}
                className="w-full"
              >
                Cube.asia
              </Button>
            </Link>
            <Link href="/login">
              <Button className="w-full">Sign in</Button>
            </Link>
          </div>
        </div>
      </div>

      {/* Mobile dropdown with animation */}
    </>
  );
};

export default PublicNavbar;
